import { render, staticRenderFns } from "./DownloadBanner.vue?vue&type=template&id=75dba6a8&scoped=true&"
import script from "./DownloadBanner.vue?vue&type=script&lang=ts&"
export * from "./DownloadBanner.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadBanner.vue?vue&type=style&index=0&id=75dba6a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dba6a8",
  null
  
)

export default component.exports